import { get, isNil } from 'lodash'
import { baseUrl } from 'environments'
import { apiClient, getConfig } from 'helpers/api'
import store from 'helpers/store'
import selectors from 'selectors'
import { tryParseFloat, strEqual } from 'helpers/utils'
import { setSharedItem, getSharedItem } from 'helpers/localForage'

export const getTranslations = async (code = 'en') => {
  const url = `${baseUrl}/api/localization/${code}?useIdAsKey=false`
  const group = `GET ${url}`

  const getStorageKey = () => `translations.${code}`

  try {
    const response = await apiClient.get(url, getConfig())
    console.groupCollapsed(group)
    console.log('Results:', response)
    console.groupEnd()

    await setSharedItem(getStorageKey(), response?.data)

    return response
  } catch (error) {
    console.groupCollapsed(group)
    console.warn(error)
    console.groupEnd()

    if (!error.response) {
      const data = await getSharedItem(getStorageKey())

      if (data) {
        return { data }
      }
    }

    throw error
  }
}

export const tryGetTranslations = async ({ code, customerId }) => {
  const url = `${baseUrl}/api/localization/${code}?useIdAsKey=false&customerId=${customerId}`
  const group = `GET ${url}`

  try {
    const response = await apiClient.get(url, getConfig())
    console.groupCollapsed(group)
    console.log('Results:', response)
    console.groupEnd()

    return response
  } catch (error) {
    console.groupCollapsed(group)
    console.warn(error)
    console.groupEnd()

    throw error
  }
}

export const t = (value) => {
  const key = String(value ?? '')

  if (['', 'Error'].includes(key)) {
    return value
  }

  if (key.match(/\s/)) {
    console.warn('Use a language key for:', value)

    return value
  }

  const translations = get(store.getState(), 'i18n.translations', {})

  let translation = translations[key]

  if (isNil(translation)) {
    translation = get(
      Object.entries(translations).find((each) => strEqual(each[0], key)),
      '[1]',
    )
  }

  if (isNil(translation)) {
    console.warn('Unable to translate key:', value)

    return value
  }

  return translation
}

export const toLocaleNumber = (value = 0, options) => {
  const locale = selectors.auth.locale(store.getState())

  return value.toLocaleString ? value.toLocaleString(locale, options) : value
}

export const toLocaleCurrency = (value = 0) =>
  toLocaleNumber(tryParseFloat(value, 0), {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    style: 'currency',
    currency: 'USD',
  })
